import type { ISocial } from "../../../../types/models/social.models.types";
import { usePostHttp } from "../../http.hook";

interface IBody {
  message: string;
}

interface IResponse {
  social: ISocial;
}
export function useSocialRejectAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/socials/:id/reject",
  });
}
